import {O} from "web-vcore";
import {ignore} from "mobx-sync";

export enum AudioSettingsSubpanel {
	config = "config",
	files = "files",
}

export class AudioSettingsState {
	@O accessor subpanel = AudioSettingsSubpanel.config;

	@O accessor mainMicrophoneID = null as any;
	@O accessor mainVoiceName = null as any;
	@O accessor voiceSpeedMultiplier = 1;
	@O accessor voiceOnRingtoneChannel = false;

	@O accessor sessions_systemStartVolume_media_enabled = false;
	@O accessor sessions_systemStartVolume_media = .5; // currently only applied on Android
	@O accessor sessions_systemStartVolume_call_enabled = false;
	@O accessor sessions_systemStartVolume_call = .5; // currently only applied on Android
	@O accessor sessions_systemStartVolume_ringtone_enabled = false;
	@O accessor sessions_systemStartVolume_ringtone = .5; // currently only applied on Android
	/*@O sessions_systemStartVolume_notification_enabled = false;
	@O accessor sessions_systemStartVolume_notification = .5; // currently only applied on Android
	@O accessor sessions_systemStartVolume_alarm_enabled = false;
	@O accessor sessions_systemStartVolume_alarm = .5; // currently only applied on Android*/

	// from testing, either 1 or 1.5 seems to be the most perceptually-linear (at least around orig-volume range of ~20%)
	// (1.5 actually seems best, HOWEVER, it might differ based on eg. audio frequency/pitch -- and I don't want a non-int default unless confirmed)
	// (confirm by: eg. record TTS as sound, play both, match loudness, adjust media-player curve till any volume +/- preserves loudness match)
	@O accessor loudnessCurve_mediaPlayer = 1;
	// from testing, ~2 seems to be the most perceptually-linear (at least around orig-volume range of ~20%)
	// (I know at least that it is *way* more perceptually-linear than 1, ie. the default for the android TTS engine)
	//@O loudnessCurve_systemTTS = 2;
	@O accessor loudnessCurve_systemTTS = 1; // changed back to 1, to preserve volume-matching between "TTS baked at 100% to file, then played at X%" and "play TTS at X% directly"

	@O accessor audioFilesFilter = "";
}